declare const authSuccessBrand: unique symbol;
declare const newPasswordRequiredChallengeBrand: unique symbol;

interface AuthSuccessProps {
  idToken: string;
  accessToken: string;
  refreshToken: string;
}

interface AuthSuccessCreationProps {
  idToken?: string;
  accessToken?: string;
  refreshToken?: string;
}

export class AuthSuccess {
  declare readonly [authSuccessBrand]: never;

  readonly idToken: string;
  readonly accessToken: string;
  readonly refreshToken: string;

  private constructor(props: AuthSuccessProps) {
    this.idToken = props.idToken;
    this.accessToken = props.accessToken;
    this.refreshToken = props.refreshToken;
  }

  static create(props: AuthSuccessCreationProps): AuthSuccess {
    if (props.idToken === undefined || props.idToken === '')
      throw new Error('Invalid authentication response: missing idToken');
    if (props.accessToken === undefined || props.accessToken === '')
      throw new Error('Invalid authentication response: missing accessToken');
    if (props.refreshToken === undefined || props.refreshToken === '')
      throw new Error('Invalid authentication response: missing refreshToken');

    return new AuthSuccess({
      idToken: props.idToken,
      accessToken: props.accessToken,
      refreshToken: props.refreshToken,
    });
  }
}

export class NewPasswordRequiredChallenge {
  declare readonly [newPasswordRequiredChallengeBrand]: never;

  private constructor(readonly session: string) {}

  static create(session: string | undefined): NewPasswordRequiredChallenge {
    if (session === undefined || session === '')
      throw new Error('NEW_PASSWORD_REQUIRED challenge received without session');

    return new NewPasswordRequiredChallenge(session);
  }
}

export type AuthResult = AuthSuccess | NewPasswordRequiredChallenge;
